import { Input } from "antd";
import type { InputRef } from "antd";
import { useGridCellEditor, type CustomCellEditorProps } from "ag-grid-react";
import { useCallback, useEffect, useRef } from "react";

/**
 * Inline text editor used by log grids that should show an Ant Design input
 * instead of AG Grid's default text box.
 */
export default function AntdTextCellEditor({
  value,
  onValueChange,
  stopEditing
}: CustomCellEditorProps) {
  const inputRef = useRef<InputRef>(null);
  const focusInput = useCallback(() => {
    inputRef.current?.focus();
  }, []);

  // AG Grid calls this when editing starts (pencil click included). Without it
  // the input never takes focus, and stopEditingWhenCellsLoseFocus closes the
  // editor before it is visible.
  useGridCellEditor({ focusIn: focusInput });

  useEffect(() => {
    focusInput();
  }, [focusInput]);

  return (
    <div className="flex !h-full w-full items-center">
      <Input
        ref={inputRef}
        value={value ?? ""}
        className="w-full"
        data-testid="antd-text-cell-editor"
        onChange={(event) => onValueChange(event.target.value)}
        onPressEnter={() => stopEditing()}
      />
    </div>
  );
}
